export const getCurrentMonthAndYear = () => {
  const currentDate = new Date();
  // Note: getMonth() returns 0 for January, 1 for February, etc. So we add 1.
  const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0');
  const currentYear = currentDate.getFullYear();
  return { currentMonth, currentYear };
};

function generatePastDatesOfCurrentMonth() {
  let dates = [];
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const currentMonth = String(currentDate.getMonth() + 1).padStart(2, '0'); // Ensure two digits for month
  const today = currentDate.getDate();

  for (let day = 1; day <= today; day++) {
    // Create a date string for each day
    let dayString = String(day).padStart(2, '0'); // Ensure two digits for day
    // Combine year, month, and day to form a full date string
    let fullDateString = `${currentYear}-${currentMonth}-${dayString}T00:00:00.000Z`;
    // Push the date string into the array
    dates.push(fullDateString);
  }

  return dates;
}

export default class MockApi {
  static IsActive = false;
  static GetUserInfo = () => {
    let info = {
      firstName: '',
      lastName: '',
      type: 2,
    };

    return info;
  };

  static Auth = () => {
    let response = {
      data: {
        response: {
          code: 1,
          sessionToken: '423212a30e584786ad9f9ccc3e6d0ce3b5e2023c46b674b3725581334b69bfd2',
        },
      },
      success: false,
    };
    return Promise.resolve(response);
  };

  static Login = () => {
    let response = {
      data: {
        accessToken:
          'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzZXNzaW9uVG9rZW4iOiI0MGUyNjMwYWI2Y2RiNmNkZmExNmU1M2NjZDQ3MzQ1ZWY2ZTZhNjMyMTVlYzRmZWU2ZTNmMTVhN2E0NjAwMDA4IiwiaWF0IjoxNjY3MjQ2MDIwLCJleHAiOjE2NjczMzI0MjB9.dnGP1W1SGe_QH7DCs7DgyiGq4eUEC5JiTZ_iQChDkBU',
      },
    };
    return Promise.resolve(response);
  };

  static GetUserInfo = () => {
    let response = {
      data: {
        id: 13,
        type: 2,
        phoneNumber: '0548868955',
        firstName: 'רונן',
        lastName: 'בן שמן',
        companyId: 6,
      },
    };
    return Promise.resolve(response);
  };

  static GetDailyAnalytics = () => {
    console.log('GetDailyAnalytics');
    const dates = generatePastDatesOfCurrentMonth();
    let recentTransfersData = [
      {
        id: 417,
        amount: 1500,
        fullName: 'ינאי ביטון',
        createdAt: '2023-09-21T08:04:45.715Z',
        status: 300,
        companyName: 'ביגה מרכז זיו נווה שאנן',
      },
      {
        id: 416,
        amount: 600,
        fullName: 'אלכס אבר',
        createdAt: '2023-09-20T14:28:34.992Z',
        status: 500,
        companyName: 'ביגה מרכז זיו נווה שאנן',
      },
      {
        id: 415,
        amount: 1000,
        fullName: 'הגר אוחנה',
        createdAt: '2023-09-20T14:28:05.554Z',
        status: 500,
        companyName: 'ביגה מרכז זיו נווה שאנן',
      },
      {
        id: 414,
        amount: 550,
        fullName: 'עמרי בן אברהם',
        createdAt: '2023-09-20T12:10:48.585Z',
        status: 500,
        companyName: 'ביגה מרכז זיו נווה שאנן',
      },
      {
        id: 413,
        amount: 900,
        fullName: 'ירדן בן לולו',
        createdAt: '2023-09-20T12:09:07.226Z',
        status: 500,
        companyName: 'ביגה מרכז זיו נווה שאנן',
      },
      {
        id: 412,
        amount: 2000,
        fullName: 'גסאו גבראה',
        createdAt: '2023-09-20T12:08:06.518Z',
        status: 500,
        companyName: 'ביגה מרכז זיו נווה שאנן',
      },
      {
        id: 411,
        amount: 1800,
        fullName: 'מריאנה גנאטוס',
        createdAt: '2023-09-20T12:01:31.718Z',
        status: 500,
        companyName: 'ביגה מרכז זיו נווה שאנן',
      },
      {
        id: 410,
        amount: 900,
        fullName: 'עדי דרעי',
        createdAt: '2023-09-20T11:59:24.760Z',
        status: 500,
        companyName: 'ביגה מרכז זיו נווה שאנן',
      },
      {
        id: 409,
        amount: 1000,
        fullName: 'אסיל יוסף',
        createdAt: '2023-09-20T11:57:52.926Z',
        status: 500,
        companyName: 'ביגה מרכז זיו נווה שאנן',
      },
      {
        id: 383,
        amount: 290,
        fullName: 'מריה איפראימוב',
        createdAt: '2023-09-05T04:16:20.005Z',
        status: 500,
        companyName: 'ח.י פלסטיק',
      },
    ];

    recentTransfersData.forEach((transfer, index) => {
      // Calculate index for the dates array starting from the end
      const dateIndex = dates.length - 1 - (Math.floor(index / 2) % dates.length); // Repeat each date twice
      transfer.createdAt = dates[dateIndex];
    });

    let response = {
      data: {
        dailySum: 2700,
        monthlySum: 25024,
        monthlyAmountAvg: 650,
        activeUsers: 233,
        nonActiveUsers: 276,
        recentTransfers: recentTransfersData,
        monthlyTransfersHistory: [28564, 32044, 35054, 25024],
        monthlyLoginsHistory: [9, 11, 13, 8],
        transfersCount: 23,
        usersTransferredCount: 21,
      },
    };
    return Promise.resolve(response);
  };

  static GetEmployees = () => {
    let response = {
      data: [
        {
          id: 2,
          email: null,
          isActive: true,
          phoneNumber: '0540667491',
          createdDate: '2022-10-09T12:53:25.070Z',
          lastLogIn: '2022-10-27T13:51:45.000Z',
          branchName: 'מרינדה',
          firstName: 'עאמד',
          lastName: 'אבו חומוס',
          fullName: 'עאמד אבו חומוס',
          details: {
            govId: '29877701',
            jobTitle: 'אחמ״ש',
            jobDepartment: 'כללי',
            internalEmployeeId: '2',
            bankId: '12',
            bankAccountId: '145052',
            bankBranchId: '555',
          },
        },
        {
          id: 5,
          email: null,
          isActive: true,
          phoneNumber: '0580000122',
          createdDate: '2022-10-20T08:38:12.801Z',
          lastLogIn: '2022-10-26T07:09:27.000Z',
          branchName: 'מרינדה',
          firstName: 'פרידה',
          lastName: 'אבוטבול',
          fullName: null,
          details: {
            govId: '13097324',
            jobTitle: 'עובד כללי',
            jobDepartment: 'מחסן',
            internalEmployeeId: '5',
            bankId: '11',
            bankAccountId: '09877',
            bankBranchId: '121',
          },
        },
        {
          id: 122,
          email: null,
          isActive: true,
          phoneNumber: '0501218767',
          createdDate: '2022-10-20T08:38:12.801Z',
          lastLogIn: '2022-10-26T07:09:27.000Z',
          branchName: 'מרינדה',
          firstName: 'אחמד',
          lastName: 'טאה',
          fullName: null,
          details: {
            govId: '854008661',
            jobTitle: 'עובד כללי',
            jobDepartment: 'מחסן',
            internalEmployeeId: '122',
            bankId: '16',
            bankAccountId: '1123311',
            bankBranchId: '667',
          },
        },
        {
          id: 133,
          email: null,
          isActive: true,
          phoneNumber: '0511123955',
          createdDate: '2022-10-20T08:38:12.801Z',
          lastLogIn: '2022-10-26T07:09:27.000Z',
          branchName: 'מרינדה',
          firstName: 'ראגח',
          lastName: 'טאה',
          fullName: null,
          details: {
            govId: '976063941',
            jobTitle: 'עובד כללי',
            jobDepartment: 'מחסן',
            internalEmployeeId: '133',
            bankId: '16',
            bankAccountId: '1123311',
            bankBranchId: '667',
          },
        },
        {
          id: 134,
          email: null,
          isActive: false,
          phoneNumber: '0540007678',
          createdDate: '2022-10-20T08:38:12.801Z',
          lastLogIn: '2022-10-26T07:09:27.000Z',
          branchName: 'מרינדה',
          firstName: 'גילה',
          lastName: 'יעקב',
          fullName: null,
          details: {
            govId: '28648822',
            jobTitle: 'עובד כללי',
            jobDepartment: 'מחסן',
            internalEmployeeId: '134',
            bankId: '16',
            bankAccountId: '1123311',
            bankBranchId: '667',
          },
        },
        {
          id: 135,
          email: null,
          isActive: true,
          phoneNumber: '0525455333',
          createdDate: '2022-10-20T08:38:12.801Z',
          lastLogIn: '2022-10-26T07:09:27.000Z',
          branchName: 'מרינדה',
          firstName: 'אשרף',
          lastName: 'פראחן',
          fullName: null,
          details: {
            govId: '304929854',
            jobTitle: 'עובד כללי',
            jobDepartment: 'מחסן',
            internalEmployeeId: '122',
            bankId: '16',
            bankAccountId: '1123311',
            bankBranchId: '667',
          },
        },
        {
          id: 120,
          email: null,
          isActive: true,
          phoneNumber: '0511100995',
          createdDate: '2022-10-20T08:38:12.801Z',
          lastLogIn: '2022-10-26T07:09:27.000Z',
          branchName: 'מרינדה',
          firstName: 'מוחמד',
          lastName: 'פרחאן',
          fullName: null,
          details: {
            govId: '318750312',
            jobTitle: 'עובד כללי',
            jobDepartment: 'מחסן',
            internalEmployeeId: '122',
            bankId: '16',
            bankAccountId: '1123311',
            bankBranchId: '667',
          },
        },
      ],
    };
    return Promise.resolve(response);
  };

  static searchByQuery(path, query) {
    const allUsers = [
      {
        id: 2,
        email: null,
        isActive: true,
        phoneNumber: '0540667491',
        createdDate: '2022-10-09T12:53:25.070Z',
        lastLogIn: '2022-10-27T13:51:45.000Z',
        branchName: 'מרינדה',
        firstName: 'רומי',
        lastName: 'טל',
        fullName: null,
        details: {
          govId: '29877701',
          jobTitle: 'אחמ״ש',
          jobDepartment: 'כללי',
          internalEmployeeId: '2',
          bankId: '12',
          bankAccountId: '145052',
          bankBranchId: '555',
        },
        companyName: 'מרינדה',
      },
      {
        id: 5,
        email: null,
        isActive: true,
        phoneNumber: '0580000122',
        createdDate: '2022-10-20T08:38:12.801Z',
        lastLogIn: '2022-10-26T07:09:27.000Z',
        branchName: 'מרינדה',
        firstName: 'פרידה',
        lastName: 'אבוטבול',
        fullName: null,
        details: {
          govId: '13097324',
          jobTitle: 'מטבח',
          jobDepartment: 'מחסן',
          internalEmployeeId: '5',
          bankId: '11',
          bankAccountId: '09877',
          bankBranchId: '121',
        },
        companyName: 'מרינדה',
      },
      {
        id: 122,
        email: null,
        isActive: true,
        phoneNumber: '0501218767',
        createdDate: '2022-10-20T08:38:12.801Z',
        lastLogIn: '2022-10-26T07:09:27.000Z',
        branchName: 'מרינדה',
        firstName: 'יניב',
        lastName: 'ברק',
        fullName: null,
        details: {
          govId: '854008661',
          jobTitle: 'מלצר',
          jobDepartment: 'מחסן',
          internalEmployeeId: '122',
          bankId: '16',
          bankAccountId: '1123311',
          bankBranchId: '667',
        },
        companyName: 'מרינדה',
      },
      {
        id: 133,
        email: null,
        isActive: true,
        phoneNumber: '0511123955',
        createdDate: '2022-10-20T08:38:12.801Z',
        lastLogIn: '2022-10-26T07:09:27.000Z',
        branchName: 'מרינדה',
        firstName: 'חגית',
        lastName: 'מלכה',
        fullName: null,
        details: {
          govId: '976063941',
          jobTitle: 'עובד כללי',
          jobDepartment: 'מחסן',
          internalEmployeeId: '133',
          bankId: '16',
          bankAccountId: '1123311',
          bankBranchId: '667',
        },
        companyName: 'מרינדה',
      },
      {
        id: 134,
        email: null,
        isActive: false,
        phoneNumber: '0540007678',
        createdDate: '2022-10-20T08:38:12.801Z',
        lastLogIn: '2022-10-26T07:09:27.000Z',
        branchName: 'מרינדה',
        firstName: 'גילה',
        lastName: 'יעקב',
        fullName: null,
        details: {
          govId: '28648822',
          jobTitle: 'מטבח',
          jobDepartment: 'מחסן',
          internalEmployeeId: '134',
          bankId: '16',
          bankAccountId: '1123311',
          bankBranchId: '667',
        },
        companyName: 'מרינדה',
      },
      {
        id: 135,
        email: null,
        isActive: true,
        phoneNumber: '0525455333',
        createdDate: '2022-10-20T08:38:12.801Z',
        lastLogIn: '2022-10-26T07:09:27.000Z',
        branchName: 'מרינדה',
        firstName: 'איליי',
        lastName: 'מורן',
        fullName: null,
        details: {
          govId: '304929854',
          jobTitle: 'עובד כללי',
          jobDepartment: 'מחסן',
          internalEmployeeId: '122',
          bankId: '16',
          bankAccountId: '1123311',
          bankBranchId: '667',
        },
        companyName: 'מרינדה',
      },
      {
        id: 120,
        email: null,
        isActive: true,
        phoneNumber: '0511100995',
        createdDate: '2022-10-20T08:38:12.801Z',
        lastLogIn: '2022-10-26T07:09:27.000Z',
        branchName: 'מרינדה',
        firstName: 'נימרוד',
        lastName: 'גטיניו',
        fullName: null,
        details: {
          govId: '318750312',
          jobTitle: 'עובד כללי',
          jobDepartment: 'מחסן',
          internalEmployeeId: '122',
          bankId: '16',
          bankAccountId: '1123311',
          bankBranchId: '667',
        },
        companyName: 'מרינדה',
      },
      {
        id: 6,
        email: null,
        isActive: true,
        phoneNumber: '0540667491',
        createdDate: '2022-10-09T12:53:25.070Z',
        lastLogIn: '2022-10-27T13:51:45.000Z',
        branchName: 'מרינדה',
        firstName: 'אדיר',
        lastName: 'כהן',
        fullName: 'אדיר כהן',
        details: {
          govId: '29877701',

          jobTitle: 'מלצר',
          jobDepartment: 'Unknown',
          internalEmployeeId: '6',
          bankId: '1',
          bankAccountId: '145052',
          bankBranchId: '555',
        },
        companyName: 'מרינדה',
      },
      {
        id: 136,
        email: null,
        isActive: true,
        phoneNumber: '0580000122',
        createdDate: '2022-10-20T08:38:12.801Z',
        lastLogIn: '2022-10-26T07:09:27.000Z',
        branchName: 'מרינדה',
        firstName: 'מורן',
        lastName: 'וסלזם',
        fullName: 'מורן וסלזם',
        details: {
          govId: '318750312',
          jobTitle: 'מלצר',
          jobDepartment: 'Unknown',
          internalEmployeeId: '5',
          bankId: '16',
          bankAccountId: '1123311',
          bankBranchId: '667',
        },
        companyName: 'מרינדה',
      },
      {
        id: 137,
        email: null,
        isActive: true,
        phoneNumber: '0525455333',
        createdDate: '2022-10-20T08:38:12.801Z',
        lastLogIn: '2022-10-26T07:09:27.000Z',
        branchName: 'מרינדה',
        firstName: 'נתנאל',
        lastName: 'ברנס',
        fullName: null,
        details: {
          govId: '304929854',
          jobTitle: 'עובד כללי',
          jobDepartment: 'מחסן',
          internalEmployeeId: '122',
          bankId: '16',
          bankAccountId: '1123311',
          bankBranchId: '667',
        },
        companyName: 'מרינדה',
      },
      {
        id: 139,
        email: null,
        isActive: true,
        phoneNumber: '0511100995',
        createdDate: '2022-10-20T08:38:12.801Z',
        lastLogIn: '2022-10-26T07:09:27.000Z',
        branchName: 'מרינדה',
        firstName: 'עדי',
        lastName: 'דרעי',
        fullName: null,
        details: {
          govId: '318750312',
          jobTitle: 'עובד כללי',
          jobDepartment: 'מחסן',
          internalEmployeeId: '122',
          bankId: '16',
          bankAccountId: '1123311',
          bankBranchId: '667',
        },
        companyName: 'מרינדה',
      },
      {
        id: 139,
        email: null,
        isActive: true,
        phoneNumber: '0540667491',
        createdDate: '2022-10-09T12:53:25.070Z',
        lastLogIn: '2022-10-27T13:51:45.000Z',
        branchName: 'מרינדה',
        firstName: 'טל',
        lastName: 'שמש',
        fullName: 'טל שמש',
        details: {
          govId: '29877701',
          jobTitle: 'מלצר',
          jobDepartment: 'Unknown',
          internalEmployeeId: '6',
          bankId: '1',
          bankAccountId: '145052',
          bankBranchId: '555',
        },
        companyName: 'מרינדה',
      },
      {
        id: 140,
        email: null,
        isActive: true,
        phoneNumber: '0580000122',
        createdDate: '2022-10-20T08:38:12.801Z',
        lastLogIn: '2022-10-26T07:09:27.000Z',
        branchName: 'מרינדה',
        firstName: 'עידן',
        lastName: 'מנדלוביץ',
        fullName: null,
        details: {
          govId: '318750312',
          jobTitle: 'מלצר',
          jobDepartment: 'Unknown',
          internalEmployeeId: '5',
          bankId: '16',
          bankAccountId: '1123311',
          bankBranchId: '667',
        },
        companyName: 'מרינדה',
      },
    ];

    let filteredUsers = allUsers;

    // Example of filtering logic based on query parameters
    if (query.firstName) {
      filteredUsers = filteredUsers.filter((user) => user.firstName.includes(query.firstName));
    }
    if (query.lastName) {
      filteredUsers = filteredUsers.filter((user) => user.lastName.includes(query.lastName));
    }
    if (query.phoneNumber) {
      filteredUsers = filteredUsers.filter((user) => user.lastName.includes(query.lastName));
    }
    if (query.status) {
      filteredUsers = filteredUsers.filter((user) => user.lastName.includes(query.lastName));
    }

    const page = query.page || 1;
    const resultsPerPage = query.resultsPerPage || 20;
    const startIndex = (page - 1) * resultsPerPage;
    const paginatedUsers = filteredUsers.slice(startIndex, startIndex + resultsPerPage);

    const response = {
      data: {
        users: paginatedUsers,
        totalCount: filteredUsers.length,
        totalPages: Math.ceil(filteredUsers.length / resultsPerPage),
        query: query,
      },
    };

    return Promise.resolve(response);
  }

  static GetTransfers = () => {
    const dates = generatePastDatesOfCurrentMonth();
    let transfersData = [
      {
        id: 6,
        amount: 800,
        fullName: 'אדיר כהן',
        branchName: 'מרינדה',
        govId: '29877701',
        bankId: '1',
        branchId: '555',
        accountId: '145052',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },
      {
        id: 5,
        amount: 1500,
        fullName: 'מורן וסלזם',
        branchName: 'מרינדה',
        govId: '318750312',
        bankId: '16',
        bankAccountId: '1123311',
        bankBranchId: '667',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },
      {
        id: 8,
        amount: 950,
        fullName: 'נתנאל ברנס',
        branchName: 'מרינדה',
        govId: '201147934',
        bankId: '1',
        branchId: '555',
        accountId: '145052',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },
      {
        id: 7,
        amount: 2000,
        fullName: 'שלומי אליאס',
        branchName: 'מרינדה',
        govId: '318750312',
        bankId: '16',
        bankAccountId: '1123311',
        bankBranchId: '667',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },

      {
        id: 9,

        amount: 750,

        fullName: 'מריאנה גנאטוס',
        branchName: 'מרינדה',
        govId: '201147934',
        bankId: '1',
        branchId: '555',
        accountId: '145052',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },
      {
        id: 10,
        amount: 1300,
        fullName: 'מורן וסלזם',
        branchName: 'מרינדה',
        govId: '209142634',
        bankId: '1',
        branchId: '555',
        accountId: '145052',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },
      {
        id: 11,
        amount: 1500,
        fullName: 'ליאב חלבי מלכה',
        branchName: 'מרינדה',
        govId: '208301192',
        bankId: '16',
        bankAccountId: '1123311',
        bankBranchId: '667',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },
      {
        id: 12,
        amount: 1100,
        fullName: 'טל שמש',
        branchName: 'מרינדה',
        govId: '212178685',
        bankId: '1',
        branchId: '555',
        accountId: '145052',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },
      {
        id: 13,
        amount: 2000,
        fullName: 'ויקטור אנקודינוב',
        branchName: 'מרינדה',
        govId: '213037096',
        bankId: '16',
        bankAccountId: '1123311',
        bankBranchId: '667',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },

      {
        id: 14,

        amount: 1600,

        fullName: 'ניקה בילזבסקי',
        branchName: 'מרינדה',
        govId: '318315595',
        bankId: '1',
        branchId: '555',
        accountId: '145052',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },
      {
        id: 15,
        amount: 1000,
        fullName: 'טטיאנה מרנצ׳נקו',
        branchName: 'מרינדה',
        govId: '213731672',
        bankId: '1',
        branchId: '555',
        accountId: '145052',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },
      {
        id: 16,
        amount: 1500,
        fullName: 'גפן פוריה',
        branchName: 'מרינדה',
        govId: '318750312',
        bankId: '16',
        bankAccountId: '1123311',
        bankBranchId: '667',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },
      {
        id: 17,
        amount: 900,
        fullName: 'מור פיניקה',
        branchName: 'מרינדה',
        govId: '327708970',
        bankId: '1',
        branchId: '555',
        accountId: '145052',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },
      {
        id: 18,
        amount: 1600,
        fullName: 'אגם פרץ',
        branchName: 'מרינדה',
        govId: '318750312',
        bankId: '16',
        bankAccountId: '1123311',
        bankBranchId: '667',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },

      {
        id: 19,

        amount: 750,

        fullName: 'יאיר ביטון',
        branchName: 'מרינדה',
        govId: '207733908',
        bankId: '1',
        branchId: '555',
        accountId: '145052',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },
      {
        id: 20,
        amount: 1500,
        fullName: 'בר חן',
        branchName: 'מרינדה',
        govId: '326162765',
        bankId: '16',
        bankAccountId: '1123311',
        bankBranchId: '667',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },
      {
        id: 21,
        amount: 900,
        fullName: 'גליה אפלבאום',
        branchName: 'מרינדה',
        govId: '327708454',
        bankId: '1',
        branchId: '555',
        accountId: '145052',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },
      {
        id: 22,
        amount: 1500,
        fullName: 'יאיר ביטון',
        branchName: 'מרינדה',
        govId: '318659312',
        bankId: '16',
        bankAccountId: '1123311',
        bankBranchId: '667',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },

      {
        id: 23,

        amount: 1300,

        fullName: 'למא גנטוס',
        branchName: 'מרינדה',
        govId: '207733908',
        bankId: '1',
        branchId: '555',
        accountId: '145052',
        createdAt: '',
        status: 500,
        companyName: 'מרינדה',
      },
    ];

    transfersData.forEach((transfer, index) => {
      // Calculate index for the dates array starting from the end
      const dateIndex = dates.length - 1 - (Math.floor(index / 2) % dates.length); // Repeat each date twice
      transfer.createdAt = dates[dateIndex];
    });

    let response = {
      data: transfersData,
    };

    return Promise.resolve(response);
  };

  static GetCompanyReports = () => {
    const { currentMonth, currentYear } = getCurrentMonthAndYear();

    const payPeriod = `${currentMonth}/${currentYear}`;
    let response = {
      data: [
        {
          companyId: 4,
          companyName: 'מרינדה',
          payPeriod: payPeriod,
          transfersAmount: 35000,
          usersTransfersFee: 25 * 7.99,

          usersRequestedTransfer: 0,
          activeUsers: 230,
          companyServiceSubscriptionFee: 15,
          totalCompanyServiceSubscriptionFee: 0,
          settlementTotalAmount: 35000 + 25 * 7.99,
          state: 1,
          documentId:
            '{"2":285761167,"חשבונית מס - עמלות משיכה עובדים":285704336,"דרישת תשלום - העברת מקדמות עובדים":285614915}',
        },
      ],
    };
    return Promise.resolve(response);
  };

  static ExportPayrollData = () => {
    let response = {
      data: [
        {
          uid: '120',
          name: 'מוחמד פרחאן',
          transfers: 844,
        },
        {
          uid: '2',
          name: 'עאמד אבו חומוס',
          transfers: 807,
        },
        {
          uid: '122',
          name: 'אחמד טאה',
          transfers: 957,
        },
        {
          uid: '133',
          name: 'רגאח טאה',
          transfers: 757,
        },
      ],
    };
    return Promise.resolve(response);
  };
  static downloadReport = () => {
    let response = {
      data: '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',
    };

    return Promise.resolve(response);
  };

  static GetApplicationDetails = () => {
    let response = {
      data: {
        application: {
          id: 1,
          amount: 800,
          status: 500,
          createdAt: '2024-01-15T10:30:00Z',
          transferFee: 7.99,
          promotions: [
            {
              type: 'no_transfer_fee',
              message: 'First transfer is free',
              addon: '0'
            }
          ],
          userAddedInfo: 'Emergency transfer for medical expenses',
          bankReference: 'REF123456789',
          bankActivityReference: 'ACT987654321',
          transferId: 'TID_123456'
        },
        transferLog: [
          {
            id: 1,
            action: 'PENDING_OTP_CONFIRM',
            state: 200,
            createdDate: '2025-08-16T15:25:08Z',
            metadata: '{"phoneNumber":"0549495744","cacheValue":{"otpToken":"412916","transferId":"765030.4010","sessionId":"8544b709331a42396b11ceb4e72989a55b768d5da89f13177052be7ca9e67d55","bankAccount":{"bankId":"11","branchId":"321","accountId":"169337113"},"transferAmount":1000,"transferFee":0,"promotions":[]}}'
          },
          {
            id: 2,
            action: 'PENDING_TRANSFER',
            state: 300,
            createdDate: '2025-08-16T15:25:23Z',
            metadata: '{"bankAccount":{"bankId":"11","branchId":"321","accountId":"169337113"},"transferAmount":1000,"transferFee":0,"promotions":[]}'
          },
          {
            id: 3,
            action: 'PENDING_APPROVAL',
            state: 400,
            createdDate: '2025-08-17T12:11:35Z',
            metadata: '{"bankId":"11","branchId":"321","accountId":"169337113","bankRecipientName":"עמר חמאמי","amount":1000}'
          },
          {
            id: 4,
            action: 'TRANSFERRED',
            state: 500,
            createdDate: '2025-08-17T14:30:00Z',
            metadata: 'Transfer completed successfully'
          }
        ]
      }
    };

    return Promise.resolve(response);
  };

  static GetTopReferrers = () => {
    let response = {
      data: [
        {
          userId: 1,
          fullName: 'יוסי כהן',
          companyName: 'חברת הטכנולוגיה',
          referralCode: 'YOSSI123',
          totalReferrals: 15,
          registeredOnly: 3,
          withApplications: 12,
          applicationConversionRate: 80.0,
          registrationDate: '2024-01-15T10:30:00Z'
        },
        {
          userId: 2,
          fullName: 'שרה לוי',
          companyName: 'חברת השירותים',
          referralCode: 'SARAH456',
          totalReferrals: 8,
          registeredOnly: 2,
          withApplications: 6,
          applicationConversionRate: 75.0,
          registrationDate: '2024-02-20T14:15:00Z'
        },
        {
          userId: 3,
          fullName: 'דוד אברהם',
          companyName: 'חברת הבנייה',
          referralCode: 'DAVID789',
          totalReferrals: 12,
          registeredOnly: 5,
          withApplications: 7,
          applicationConversionRate: 58.33,
          registrationDate: '2024-03-10T09:45:00Z'
        }
      ]
    };

    return Promise.resolve(response);
  };

  static SearchUsersWithReferrals = () => {
    let response = {
      data: {
        users: [
          {
            userId: 1,
            fullName: 'יוסי כהן',
            companyName: 'חברת הטכנולוגיה',
            referralCode: 'YOSSI123',
            totalReferrals: 15,
            registeredOnly: 3,
            withApplications: 12,
            applicationConversionRate: 80.0,
            registrationDate: '2024-01-15T10:30:00Z'
          }
        ],
        totalCount: 1
      }
    };

    return Promise.resolve(response);
  };

  static GetUserReferralDetails = () => {
    let response = {
      data: {
        referrer: {
          id: 1,
          fullName: 'יוסי כהן',
          companyName: 'חברת הטכנולוגיה',
          referralCode: 'YOSSI123',
          registrationDate: '2024-01-15T10:30:00Z'
        },
        referredUsers: {
          registeredOnly: [
            {
              id: 101,
              fullName: 'אמיר ישראל',
              companyName: 'חברת הטכנולוגיה',
              registrationDate: '2025-08-10T12:00:00Z',
              referralState: 'registered_only',
              totalApplications: 0,
              daysSinceRegistration: 8
            },
            {
              id: 102,
              fullName: 'רונית גולן',
              companyName: 'חברת הטכנולוגיה',
              registrationDate: '2025-08-12T15:30:00Z',
              referralState: 'registered_only',
              totalApplications: 0,
              daysSinceRegistration: 6
            }
          ],
          withApplications: [
            {
              id: 103,
              fullName: 'מיכל דוד',
              companyName: 'חברת הטכנולוגיה',
              registrationDate: '2025-08-05T09:15:00Z',
              referralState: 'application_created',
              firstApplicationDate: '2025-08-07T14:20:00Z',
              totalApplications: 2,
              daysSinceRegistration: 13,
              daysToFirstApplication: 2
            },
            {
              id: 104,
              fullName: 'עומר חמאמי',
              companyName: 'חברת הטכנולוגיה',
              registrationDate: '2025-08-01T11:45:00Z',
              referralState: 'application_created',
              firstApplicationDate: '2025-08-03T16:10:00Z',
              totalApplications: 1,
              daysSinceRegistration: 17,
              daysToFirstApplication: 2
            }
          ]
        },
        stats: {
          totalReferrals: 4,
          registeredOnly: 2,
          withApplications: 2,
          conversionRate: 50.0,
          avgDaysToFirstApplication: 2
        }
      }
    };

    return Promise.resolve(response);
  };

  static getTransfersListWithFee = () => {
    let response = {
      data: [
        {
          totalTransferFee: '7.99',
          totalAmount: '950.00',
          employeeName: 'יעקב לוינשטיין',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '1650.00',
          employeeName: 'סמירה חסן',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '1600.00',
          employeeName: 'אורי שפירא',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '1350.00',
          employeeName: 'מירב כהן',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '1175.00',
          employeeName: 'איתן גולדשטיין',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '1450.00',
          employeeName: "ג'מילה עבד אל-חלים",
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '725.00',
          employeeName: 'מורן שרון',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '1800.00',
          employeeName: 'יעל רזניק',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '1120.00',
          employeeName: 'סעיד אבו ראש',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '599.00',
          employeeName: 'תומר גולדברג',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '1700.00',
          employeeName: 'רונית כהן',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '650.00',
          employeeName: 'אביבה לוי',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '1900.00',
          employeeName: 'יוסף אל-חמיד',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '2175.00',
          employeeName: 'אורית פלד',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '1100.00',
          employeeName: 'דניאל שוורץ',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '1450.00',
          employeeName: 'אסמא סלים',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '1250.00',
          employeeName: 'נועה גרינברג',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '1750.00',
          employeeName: 'אלעד פרץ',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '675.00',
          employeeName: 'שרה גוטמן',
        },
        {
          totalTransferFee: '7.99',
          totalAmount: '1200.00',
          employeeName: 'עמר חסן',
        },
      ],
    };
    return Promise.resolve(response);
  };
}
